















import { defineComponent } from '@vue/composition-api';

/**
 * Loader component for use as inplace element (e.g. within buttons) or as fullscreen
 */
export default defineComponent({
	props: {
		/**
		 * Show loader as fullscreen with backdrop
		 */
		fullscreen: Boolean,
		/**
		 * Show loader as white
		 */
		white: Boolean,
	},
});
